import React, { useState } from "react";
import './Dashboard.css'
import Header from '../Header/Header'
import EnhancedTable from '../EnhancedTable/EnhancedTable'
import FilterListIcon from '@material-ui/icons/FilterList';
import { BASE_URL } from "../../constants";

function getCallApi(launch, status) {
    let callApi;
    switch (launch) {
        case "all":
            callApi = `${BASE_URL}/launches`;
            break;
        case "upcoming":
            callApi = `${BASE_URL}/launches/upcoming`;
            break;
        case "past":
            callApi = `${BASE_URL}/launches/past`;
            break;
        default:
            callApi = `${BASE_URL}/launches`;
    }
    if (status === "all") return callApi;
    return `${callApi}?launch_success=${status === "successful"}`;
}

function Dashboard() {
    const [launch, setLaunch] = useState("all");
    const [launchStatus, setLaunchStatus] = useState("successful");

    return (
        <div className='dashboard'>
            <Header />
            <div className="dashboard_launchStatus">

                <div className="dashboard_filter">
                    <div>
                        <FilterListIcon className='dashboard_filterIcon'/>
                    </div>
                    <div className="dashboard_filterBox">
                    <select
                            value={launch}
                            className="rounded border border-gray-700 bg-gray-800 appearance-none py-2 focus:outline-none focus:border-blue-500 mr-5 pr-10"
                            onChange={(e) =>
                                setLaunch(e.target.value)
                            }
                        >
                            <option value="all">All Launches</option>
                            <option value="upcoming">Upcoming Launches</option>
                            <option value="past">
                                Past Launches
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <EnhancedTable callApi={getCallApi(launch, launchStatus)} launch={launch}/>
        </div>
    )
}

export default Dashboard
